import React from "react";
import { Row } from "react-bootstrap";

function Github() {
  const leetcodeUsername = "diksha_jha";

  return (
    <Row
      className="leetcode-section"
      style={{
        justifyContent: "center",
        paddingBottom: "10px",
        color: "white",
      }}
    >
      <h1 className="project-heading pb-4 leetcode-heading" style={{ paddingBottom: "20px" }}>
        LeetCode <strong className="blue">Stats</strong>
      </h1>
      <a
        href={`https://leetcode.com/${leetcodeUsername}/`}
        target="_blank"
        rel="noreferrer"
        className="leetcode-card-link"
      >
        <img
          src={`https://leetcard.jacoblin.cool/${leetcodeUsername}?theme=dark&font=JetBrains%20Mono&ext=heatmap`}
          alt="LeetCode stats card"
          className="leetcode-card-image"
        />
      </a>
    </Row>
  );
}

export default Github;
